export const DOMAIN = 'dsarFormDetails';
